import { MParticleShape } from './elog/mparticle_load';

type CommonsWindow = typeof window & {
  mParticle?: Partial<MParticleShape>;
  criteo_q?: PlainObject[];
};

export default window as CommonsWindow;



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/window_wrapper.ts